import React, { useEffect, useState } from 'react'
import './Banner.css'
import { getDailyTopOneTrending, getLeaderboardData, getOneRandomPost, getUserProfileInfoWithId, skjdngkjndsjknm } from '../../services/f';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../../features/currentUser';
import { useSelector } from 'react-redux';
import { auth } from '../../firebase';

function Banner() {
    const [toptrendingpost, settoptrendingpost] = useState(null);
    const [toptrendinguser, settoptrendinguser] = useState(null);
    const navigate = useNavigate()
    let currentUser = useSelector(getCurrentUser).currentUser?.currentUser

    const [leaderboard, setLeaderboard] = useState([]);
    const [loading, setLoading] = useState(true);
    const [f, ssdffsdfsdetF] = useState();

    const [inviteCount, setInviteCount] = useState(0);
    const [isShareClicked, setIsShareClicked] = useState(false);

    // Animate counter on mount
    useEffect(() => {
        const fetchLeaderboard = async () => {
            try {
                const data = await getLeaderboardData();
                setLeaderboard(data);
                skjdngkjndsjknm(auth.currentUser.uid).then(ssdffsdfsdetF)
            } catch (err) {
                console.error("Failed to load leaderboard:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchLeaderboard();
    }, []);

    const handleShare = () => {
        setIsShareClicked(true);
        // Here you would integrate with your actual sharing/invitation system
        console.log('Share invitation triggered');
        navigator.clipboard.writeText(`premsi.com/?referral=${currentUser?.displayName}`)
        setTimeout(() => {
            setIsShareClicked(false);
        }, 10000);
    };

    const getRankStyle = (rank) => {
        const baseStyle = {
            width: '30px',
            height: '30px',
            borderRadius: '15px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: '700',
            fontSize: '14px',
            marginRight: '15px'
        };

        switch (rank) {
            case 1:
                return {
                    ...baseStyle,
                    background: 'linear-gradient(135deg, #ffd700, #ffed4e)',
                    color: '#333'
                };
            case 2:
                return {
                    ...baseStyle,
                    background: 'linear-gradient(135deg, #c0c0c0, #e5e5e5)',
                    color: '#333'
                };
            case 3:
                return {
                    ...baseStyle,
                    background: 'linear-gradient(135deg, #cd7f32, #daa520)',
                    color: '#333'
                };
            default:
                return {
                    ...baseStyle,
                    background: 'rgba(255, 255, 255, 0.2)',
                    color: 'white'
                };
        }
    }

    /*useEffect(() => {
        //console.log("load Banner")
        getDailyTopOneTrending().then((post) => {
            //console.log("post1", post)
            if (post !== "empty") {
                settoptrendingpost(post)
                getUserProfileInfoWithId(post[1].creator).then((user) => (settoptrendinguser(user)))
            } else {
                getOneRandomPost(currentUser).then((post) => {
                    //console.log("this is random post", post)
                    settoptrendingpost(post)
                    getUserProfileInfoWithId(post[1].creator).then((user) => (settoptrendinguser(user)))
                })
            }
        })

    }, []);

    return (
        <header className='banner' style={{ backgroundImage: `url(${toptrendingpost ? (toptrendingpost[1]?.type === "image" ? toptrendingpost[1]?.media[0] : toptrendingpost[1]?.media[1]) : null})` }} >
            <div className='banner__contents'>
                <p style={{ fontSize: 26, fontWeight: "bold" }}>{toptrendinguser?.displayName}</p>
                <button className='banner__button' onClick={() => navigate("/post?id=" + toptrendingpost[0])}>See Post</button>
                <button className='banner__button' onClick={() => navigate("/user?id=" + toptrendinguser?.uid)}>Go To User</button>
                {toptrendingpost ? <h2 className='banner__description' style={{ color: "white" }}>{toptrendingpost[1]?.description}</h2> : null}
            </div>
        </header >
    )*/

    return (
        <div style={{ fontFamily: '"Klarheit Grotesk Regular", sans-serif' }}>
            {/* Main giveaway banner */}
            <div style={{
                background: 'linear-gradient(135deg, #009ffd 0%, #2a2a72 100%)',
                minHeight: '200px',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                alignItems: 'center',
                justifyContent: "center",
                padding: '50px 20px'
            }}>
                {/* Scroll down indicator */}
                <div className="scroll-indicator" style={{ position: "absolute", top: 0, margin: "auto" }}>
                    <div className="scroll-text">
                        ↓ Scroll down to see posts ↓
                    </div>
                </div>
                {/* Animated background pattern */}
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cdefs%3E%3Cpattern id='grid' width='10' height='10' patternUnits='userSpaceOnUse'%3E%3Cpath d='M 10 0 L 0 0 0 10' fill='none' stroke='white' stroke-width='0.5' opacity='0.1'/%3E%3C/pattern%3E%3C/defs%3E%3Crect width='100' height='400' fill='url(%23grid)'/%3E%3C/svg%3E")`,
                    animation: 'drift 20s linear infinite'
                }} />

                {/* Floating particles */}
                {[...Array(9)].map((_, i) => (
                    <div
                        key={i}
                        style={{
                            position: 'absolute',
                            background: 'rgba(255, 255, 255, 0.1)',
                            borderRadius: '50%',
                            width: `${4 + (i % 3) * 2}px`,
                            height: `${4 + (i % 3) * 2}px`,
                            left: `${10 + i * 10}%`,
                            animation: `float 6s ease-in-out infinite ${i * 0.5}s`
                        }}
                    />
                ))}

                <div style={{
                    margin: '0 auto',
                    width: '100%',
                    position: 'relative',
                    zIndex: 2,
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "space-between",
                    flexDirection: "row"
                }}>
                    {/* Top row: Prize section and User stats side by side */}
                    <div className='leftbannerside'>
                        {/* Prize Section */}
                        <div style={{
                            flex: 1,
                            textAlign: 'center',
                            color: 'white'
                        }}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.15)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '20px',
                                padding: '30px',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                position: 'relative',
                                overflow: 'hidden'
                            }}>
                                <div style={{
                                    position: 'absolute',
                                    top: '-50%',
                                    left: '-50%',
                                    width: '200%',
                                    height: '200%',
                                    background: 'linear-gradient(45deg, transparent, rgba(255,255,255,0.1), transparent)',
                                    animation: 'shimmer 3s infinite'
                                }} />

                                <div style={{
                                    fontSize: '48px',
                                    fontWeight: '900',
                                    color: '#fff',
                                    textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                                    marginBottom: '10px',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    $500
                                </div>
                                <div style={{
                                    fontSize: '18px',
                                    opacity: 0.9,
                                    marginBottom: '15px',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    Weekly Giveaway
                                </div>
                                <div style={{
                                    fontSize: '14px',
                                    opacity: 0.8,
                                    textTransform: 'uppercase',
                                    letterSpacing: '1px',
                                    position: 'relative',
                                    zIndex: 1
                                }}>
                                    Most Invites Wins
                                </div>
                            </div>
                        </div>

                        {/* User Stats Section */}
                        <div style={{
                            textAlign: 'center',
                            color: 'white',
                            flex: 1,
                        }}>
                            <div style={{
                                background: 'rgba(255, 255, 255, 0.1)',
                                backdropFilter: 'blur(10px)',
                                borderRadius: '20px',
                                padding: '30px',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                marginBottom: '20px'
                            }}>
                                <div style={{
                                    fontSize: '36px',
                                    fontWeight: '800',
                                    color: '#fff',
                                    marginBottom: '10px',
                                    animation: 'pulse 2s infinite'
                                }}>
                                    {f?.referral}
                                </div>
                                <div style={{
                                    fontSize: '16px',
                                    opacity: 0.9,
                                    marginBottom: '20px'
                                }}>
                                    Your Invites This Week
                                </div>
                            </div>

                            <button
                                onClick={handleShare}
                                style={{
                                    background: isShareClicked
                                        ? 'linear-gradient(135deg, #00d4ff, #009ffd)'
                                        : 'linear-gradient(135deg, #ff6b6b, #ff8787)',
                                    color: 'white',
                                    border: 'none',
                                    padding: '15px 30px',
                                    borderRadius: '50px',
                                    fontSize: '16px',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    boxShadow: '0 4px 15px rgba(255, 107, 107, 0.4)',
                                    position: 'relative',
                                    overflow: 'hidden',
                                    transform: 'translateY(0)',
                                    ':hover': {
                                        transform: 'translateY(-2px)',
                                        boxShadow: '0 6px 20px rgba(255, 107, 107, 0.6)'
                                    }
                                }}
                                onMouseEnter={(e) => {
                                    e.target.style.transform = 'translateY(-2px)';
                                    e.target.style.boxShadow = '0 6px 20px rgba(255, 107, 107, 0.6)';
                                }}
                                onMouseLeave={(e) => {
                                    e.target.style.transform = 'translateY(0)';
                                    e.target.style.boxShadow = '0 4px 15px rgba(255, 107, 107, 0.4)';
                                }}
                            >
                                {isShareClicked ? '✨ Link Copied!' : '🚀 Share & Invite Friends'}
                            </button>
                        </div>
                    </div>

                    {/* Bottom row: Leaderboard */}
                    <div className='rightbannerside'>


                        <div style={{
                            background: 'rgba(255, 255, 255, 0.1)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '20px',
                            padding: '20px',
                            border: '1px solid rgba(255, 255, 255, 0.2)'
                        }}>
                            <div style={{
                                fontSize: '20px',
                                fontWeight: '700',
                                marginBottom: '20px',
                                textAlign: 'center'
                            }}>
                                🏆 Top Inviters
                            </div>
                            {leaderboard.map((user, index) => (
                                <div
                                    key={index}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        padding: '12px 0',
                                        borderBottom: index < leaderboard.length - 1 ? '1px solid rgba(255, 255, 255, 0.1)' : 'none'
                                    }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div style={getRankStyle(user.rank)}>
                                            {user.rank}
                                        </div>
                                        <div style={{
                                            fontWeight: user.isCurrentUser ? '700' : '500',
                                            color: user.isCurrentUser ? '#00d4ff' : 'white'
                                        }}>
                                            {user.name}
                                        </div>
                                    </div>
                                    <div style={{
                                        fontWeight: '700',
                                        color: '#00d4ff'
                                    }}>
                                        {user.count}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <style jsx>{`
        @keyframes drift {
          0% { transform: translateX(0); }
          100% { transform: translateX(10px); }
        }

        @keyframes shimmer {
          0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
          50% { transform: translateX(100%) translateY(100%) rotate(45deg); }
          100% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
        }

        @keyframes pulse {
          0%, 100% { transform: scale(1); }
          50% { transform: scale(1.05); }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(180deg); }
        }

        @media (max-width: 768px) {
          .banner-content {
            flex-direction: column;
            align-items: center;
          }
          
          .prize-section, .user-stats {
            min-width: 100%;
            max-width: 400px;
          }
        }
      `}</style>
        </div>
    );

}

export default Banner
